import { getAddressAsString } from '@vue/services/checkout.service'
export default address => {
  return getAddressAsString(address)
}
